export const MAX_SSO_DOMAINS = 30;

export const MAX_DOMAIN_CHAR_LENGTH = 40; // AWS COGNITO LIMIT
